export default "__VITE_ASSET__BzYMhUNy__"